<!-- Breadcrumb - Only visible on node hover -->
<div class="breadcrumb" *ngIf="hoveredNode$ | async as node">
  <div class="breadcrumb__node">{{node.label}}</div>
  <div class="breadcrumb__ancestors">
    {{nodeAncestors}}
  </div>
</div>